import { Component } from '@angular/core';
import { HistorialExtraContractualService } from "../../../../shared/services/historial_extracontractual.service";
import { HistorialContractualService } from "../../../../shared/services/historial_contractual.service";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { forkJoin } from 'rxjs/internal/observable/forkJoin';
const Swal = require("sweetalert2");


@Component({
  selector: 'app-polizas',
  templateUrl: './polizas.component.html',
  styleUrls: ['./polizas.component.scss']
})
export class PolizasComponent {
  fechaExpedicion: any;
  fechaVencimiento: any;
  formExtracontractual: FormGroup;
  formContractual: FormGroup;

  constructor(
    private historialExtracontractualService: HistorialExtraContractualService,
    private historialcontractualService: HistorialContractualService,
    private fb: FormBuilder,
    private route: ActivatedRoute
  ) {}

  ngOnInit(
  ) {
    
    this.formContractual = this.fb.group({
      fecha_expedicionRCC: [null, Validators.required],
      fecha_vencimientoRCC: [null, Validators.required],

    });

    this.formExtracontractual = this.fb.group({
      fecha_expedicionRCE: [null, Validators.required],
      fecha_vencimientoRCE: [null, Validators.required],
    });
  }

  actualizarTodosLosHistoriales() {
    const contractualValido = this.formContractual.valid;
    const extracontractualValido = this.formExtracontractual.valid;
  
    // Validación inicial: si ninguno es válido
    if (!contractualValido && !extracontractualValido) {
      Swal.fire({
        icon: 'warning',
        title: 'Formulario incompleto',
        text: 'Debes llenar al menos uno de los formularios para actualizar.',
      });
      return;
    }
  
    const acciones: any[] = [];
  
    if (extracontractualValido) {
      const { fecha_expedicionRCE, fecha_vencimientoRCE } = this.formExtracontractual.value;
      const obs = this.historialExtracontractualService.obtenerHistoriales(fecha_expedicionRCE, fecha_vencimientoRCE);
      acciones.push(obs);
    } else {
      acciones.push(null);
    }
  
    if (contractualValido) {
      const { fecha_expedicionRCC, fecha_vencimientoRCC } = this.formContractual.value;
      const obs = this.historialcontractualService.renovarHistorialesContractuales(fecha_expedicionRCC, fecha_vencimientoRCC);
      acciones.push(obs);
    } else {
      acciones.push(null);
    }
  
    forkJoin(acciones.filter(a => a !== null)).subscribe({
      next: (respuestas) => {
        if (contractualValido && extracontractualValido) {
          Swal.fire({
            icon: 'success',
            title: 'Actualización completa',
            text: 'Ambos historiales fueron renovados correctamente.',
          });
          this.formContractual.reset();
          this.formExtracontractual.reset();
        } else if (contractualValido) {
          Swal.fire({
            icon: 'success',
            title: 'Actualización RCC',
            text: 'Historial contractual renovado correctamente.',
          });
          this.formContractual.reset();
        } else if (extracontractualValido) {
          Swal.fire({
            icon: 'success',
            title: 'Actualización RCE',
            text: 'Historial extracontractual renovado correctamente.',
          });
          this.formExtracontractual.reset();
        }
      },
      error: (error) => {
        console.error('❌ Error durante la actualización de historiales:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Ocurrió un error durante la actualización. Verifica la consola.',
        });
      }
    });
  }

}